import React from "react";
import { BsPlusCircleFill } from "@react-icons/all-files/bs/BsPlusCircleFill";
import { AiFillMinusCircle } from "@react-icons/all-files/ai/AiFillMinusCircle";

import { classNames } from "repoV2/utils/common/render/classNames";
import { pluralise } from "@Utils/common";

import styles from "./merchandise.module.scss";
import useMerchandise from "./useMerchandise";

const Merchandise = () => {
    const {
        handleQuantityChange,
        getMaxCountReached,
        unitText,
        currency,
        price,
        quantity,
    } = useMerchandise();

    return (
        <div className={styles.root}>
            <div className={classNames()}>
                <div className={styles.priceDesc}>
                    <span className={styles.unitText}>{unitText}</span>
                    <span className="flexGrow" />
                    <span className={styles.price}>
                        {price ? currency : null}
                        &nbsp;
                        {price}
                    </span>
                </div>
                <div className={styles.qtyContainer}>
                    <div
                        role="button"
                        onKeyDown={() => null}
                        tabIndex={-1}
                        className={classNames(
                            styles.reduceQty,
                            quantity > 1 ? "" : styles.disabled
                        )}
                        id="merchandise-qtyUp"
                        onClick={handleQuantityChange(false)}
                    >
                        <AiFillMinusCircle />
                    </div>
                    <div className={styles.quantity}>
                        {quantity}
                        {pluralise(" item", quantity)}
                    </div>
                    <div
                        className={classNames(
                            styles.increaseQty,
                            getMaxCountReached(true) ? styles.disabled : ""
                        )}
                        id="merchandise-qtyDown"
                        role="button"
                        onKeyDown={() => null}
                        tabIndex={-1}
                        onClick={handleQuantityChange(true)}
                    >
                        <BsPlusCircleFill />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Merchandise;
